export default {
  "content": "<path d=\"M18.76 4c4.32 4.41 4.32 11.59 0 16l-1.48-1.45c3.53-3.61 3.53-9.48 0-13.09L18.76 4z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.246 5.327c.776-.41 1.754.146 1.754 1.066v11.214a1.2 1.2 0 01-1.906.971L6.176 15H3.7a1.2 1.2 0 01-1.2-1.2v-3.6A1.2 1.2 0 013.7 9h2.476l4.918-3.578.152-.095zm-4.105 5.444c-.205.149-.453.229-.706.229H4.5v2h1.935c.253 0 .5.08.706.23L11 16.035V7.964L7.14 10.77z\" fill=\"#7B61FF\"/><path d=\"M15.6 7.24c2.57 2.62 2.57 6.9 0 9.53l-1.48-1.45c1.79-1.83 1.79-4.8 0-6.63l1.48-1.45z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};